export const AuStates = [
  {
    label: 'NSW',
    value: 'NSW',
  },
  {
    label: 'VIC',
    value: 'VIC',
  },
  {
    label: 'QLD',
    value: 'QLD',
  },
  {
    label: 'SA',
    value: 'SA',
  },
  {
    label: 'WA',
    value: 'WA',
  },
  {
    label: 'TAS',
    value: 'TAS',
  },
  {
    label: 'NT',
    value: 'NT',
  },
  {
    label: 'ACT',
    value: 'ACT',
  },
];

export const AuStatesFull = [
  {
    label: 'New South Wales',
    value: 'NSW',
  },
  {
    label: 'Victoria',
    value: 'VIC',
  },
  {
    label: 'Queensland',
    value: 'QLD',
  },
  {
    label: 'South Australia',
    value: 'SA',
  },
  {
    label: 'Western Australia',
    value: 'WA',
  },
  {
    label: 'Tasmania',
    value: 'TAS',
  },
  {
    label: 'Northern Territory',
    value: 'NT',
  },
  {
    label: 'Australian Capital Territory',
    value: 'ACT',
  },
];

export const AuStatesObjects = {
  NSW: {
    label: 'New South Wales',
    value: 'NSW',
    timeZone: 'Australia/Sydney',
  },
  VIC: {
    label: 'Victoria',
    value: 'VIC',
    timeZone: 'Australia/Sydney',
  },
  QLD: {
    label: 'Queensland',
    value: 'QLD',
    timeZone: 'Australia/Sydney',
  },
  SA: {
    label: 'South Australia',
    value: 'SA',
    timeZone: 'Australia/Sydney',
  },
  WA: {
    label: 'Western Australia',
    value: 'WA',
    timeZone: 'Australia/Sydney',
  },
  TAS: {
    label: 'Tasmania',
    value: 'TAS',
    timeZone: 'Australia/Sydney',
  },
  NT: {
    label: 'Northern Territory',
    value: 'NT',
    timeZone: 'Australia/Sydney',
  },
  ACT: {
    label: 'Australian Capital Territory',
    value: 'ACT',
    timeZone: 'Australia/Sydney',
  },
};
